import React from 'react'
import type { AssetTransactionTrancheOption } from '../../../state_manager/data_models/asset_transaction_detail.ts'

// Multi-column render for the Tranche <Select> dropdown options: the holding
// context an operator needs to pick the right tranche — Fund | Security |
// Date acquired | No. Held | Principal Held | Cost Held (spec slide 4). Same
// house pattern as the distribution-lists contact option render.

const num = (v: number | null | undefined): string =>
  v == null || v === 0 ? '-' : Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })

const money = (v: number | null | undefined, symbol?: string | null): string =>
  v == null || v === 0 ? '-' : `${symbol ?? ''}${Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })}`

export const renderTrancheOption = (t: AssetTransactionTrancheOption): React.ReactNode => (
  <div style={{ lineHeight: 1.3, padding: '2px 0' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
      <span style={{ fontWeight: 500, color: t.is_open === false ? '#8c8c8c' : undefined }}>
        {t.funds__name ?? '-'} — {t.securities__name ?? '-'}
      </span>
      <span style={{ fontSize: 12 }}>
        {t.is_open === false ? (
          // closed tranches stay selectable (post-exit distributions,
          // escrow, late corrections) but are clearly badged
          <span style={{ color: '#d46b08' }}>
            Exited{t.date_exited_fmt ? ` ${t.date_exited_fmt}` : ''}
          </span>
        ) : (
          <span style={{ color: '#8c8c8c' }}>{t.date_invested_fmt ?? '-'}</span>
        )}
      </span>
    </div>
    <div style={{ fontSize: 12, color: '#8c8c8c', display: 'flex', gap: 16 }}>
      <span>No. held: {num(t.no_held)}</span>
      <span>Principal: {money(t.principal_held, t.security_currency_symbol)}</span>
      <span>Cost: {money(t.cost_held, t.currency_symbol)}</span>
    </div>
  </div>
)

export const trancheOptionFilter = (input: string, option?: AssetTransactionTrancheOption): boolean => {
  const q = (input || '').trim().toLowerCase()
  if (!q) return true
  return `${option?.funds__name ?? ''} ${option?.securities__name ?? ''} ${option?.label ?? ''}`
    .toLowerCase()
    .includes(q)
}
